import { Component } from '@theme/component';

class NaptonEliteUpgrades extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.enhance();
  }

  updatedCallback() {
    super.updatedCallback();
    this.enhance();
  }

  enhance() {
    const choices = this.refs.choices;
    const panels = this.refs.panels;
    if (!Array.isArray(choices) || !Array.isArray(panels) || choices.length !== panels.length) return;
    this.refs.menu?.setAttribute('role', 'tablist');
    const selected = choices.find(choice => choice.getAttribute('aria-selected') === 'true') || choices[0];
    for (const [index, choice] of choices.entries()) {
      choice.setAttribute('role', 'tab');
      choice.setAttribute('aria-controls', panels[index].id);
      panels[index].setAttribute('role', 'tabpanel');
      panels[index].setAttribute('aria-labelledby', choice.id);
      panels[index].setAttribute('tabindex', '0');
    }
    this.select(selected);
    this.setAttribute('data-enhanced', '');
  }

  select(choice) {
    if (!(choice instanceof HTMLElement) || !Array.isArray(this.refs.choices) || !Array.isArray(this.refs.panels)) return;
    const key = choice.dataset.upgrade;
    for (const item of this.refs.choices) {
      const active = item === choice;
      item.setAttribute('aria-selected', String(active));
      item.setAttribute('tabindex', active ? '0' : '-1');
    }
    for (const panel of this.refs.panels) {
      panel.hidden = panel.dataset.upgradePanel !== key;
    }
    this.refs.menu?.setAttribute('aria-orientation', window.matchMedia('(max-width: 760px)').matches ? 'horizontal' : 'vertical');
  }

  selectFeature(event) {
    if (!(event.target instanceof HTMLElement)) return;
    event.preventDefault();
    this.select(event.target);
  }

  handleKeydown(event) {
    const choices = this.refs.choices;
    if (!Array.isArray(choices)) return;
    const index = choices.indexOf(event.target);
    if (index < 0) return;
    let next;
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % choices.length;
    else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + choices.length) % choices.length;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = choices.length - 1;
    else if (event.key === ' ') next = index;
    else return;
    event.preventDefault();
    this.select(choices[next]);
    choices[next].focus();
  }
}

if (!customElements.get('napton-elite-upgrades')) customElements.define('napton-elite-upgrades', NaptonEliteUpgrades);
